import React from 'react'
import { bool, number, oneOfType, string } from 'prop-types'
import { css } from '@emotion/core'
import wcfViewEnum from '../../../../shared/propTypes/wcfViewEnumProps'
import ProfileImage from '../../../../shared/components/ProfileImage/ProfileImage'

const relativeDetailsStyle = (atn, faded, view) => css`
  width: 90px;
  float: ${atn % 2 === 0 ? 'left' : 'right'};
  display: block;
  align-self: center;
  margin-left: ${atn % 2 !== 0 ? '6px' : '0px'};
  opacity: ${faded ? '0.5' : '1'};
  p {
    text-align: ${atn % 2 === 0 ? 'right' : 'left'};
    padding-right: ${atn % 2 === 0 ? '6px' : '0px'};
    margin: 0;
    color: ${view === 'generations' ? '#212225' : 'white'};
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
  }
`

const lifespanDetailStyle = css`
  padding-top: 5px;
  font-size: 11px;
  font-weight: normal;
`

const portraitStyle = (atn, faded, isSelf) => css`
  float: ${atn % 2 !== 0 ? 'left' : 'right'};
  margin: 0;
  padding: auto;
  outline: none;
  opacity: ${faded ? '0.5' : '1'};
  width: ${isSelf ? '85px' : '50px'};
  height: ${isSelf ? '85px' : '50px'};
`

const personContainer = (atn, isSelf, clickable) => css`
  display: block;
  margin-right: ${atn % 2 === 0 && !isSelf ? '2.5px' : '0px'};
  margin-left: ${atn % 2 !== 0 || isSelf ? '2.5px' : '0px'};
  ${isSelf ? 'justify-content: center' : null};
  ${clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`

export default function Relative({
  name,
  surname,
  gender,
  atn,
  lifeSpan,
  userImage,
  view,
  isSelf,
  clickable = false,
  faded,
}) {
  const relativeType = (
    <>
      {!isSelf && (
        <div css={relativeDetailsStyle(atn, faded, view)}>
          <p>{name}</p>
          <p>{surname}</p>
          <p css={lifespanDetailStyle}>{lifeSpan}</p>
        </div>
      )}

      <div css={portraitStyle(atn, faded, isSelf)}>
        <ProfileImage userImage={userImage} gender={gender} name={name} border={faded ? '2px solid #FFF' : 'none'} />
      </div>
    </>
  )

  return <div css={personContainer(atn, isSelf, clickable)}>{relativeType}</div>
}

Relative.propTypes = {
  name: string,
  surname: string,
  gender: oneOfType([string, number]),
  atn: number,
  lifeSpan: string,
  userImage: string,
  view: wcfViewEnum,
  isSelf: bool,
  clickable: bool,
  faded: bool,
}
